import React from "react";

type Props = {};

const UnAuthorizedPage = (props: Props) => {
  return (
    <div>
      <h1>Unauthorized</h1>
      <p>You do not have access to view this page.</p>
    </div>
  );
};

export default UnAuthorizedPage;
